var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uni-menu" },
    [
      _c(
        "div",
        { staticClass: "uni-menu-box" },
        [
          _c(
            "el-menu",
            {
              staticClass: "uni-menu-list",
              attrs: {
                "background-color": "transparent",
                "text-color": "#fff",
                "active-text-color": "#fff",
                "default-openeds": _vm.defaultMenuIndex,
                "menu-trigger": "click",
                collapse: _vm.isCollapse,
              },
            },
            [
              _c(
                "el-menu-item",
                {
                  staticStyle: { "text-align": "right" },
                  attrs: { index: "1" },
                  on: { click: _vm.menuCollapse },
                },
                [
                  _c("i", {
                    staticClass: "iconfont iconcaidanshouqi2",
                    staticStyle: { color: "#fff", "font-size": "20px" },
                  }),
                ]
              ),
              _vm._l(_vm.menuLists, function (item) {
                return _c(
                  "div",
                  {
                    key: item.meta.title,
                    class: { isShowIconArrow: _vm.isCollapse },
                  },
                  [
                    !item.alwaysShow
                      ? _c(
                          "el-submenu",
                          { attrs: { index: item.meta.title } },
                          [
                            _c("template", { slot: "title" }, [
                              _c("i", {
                                staticClass: "iconfont",
                                class: item.meta.icon,
                              }),
                              !_vm.isCollapse
                                ? _c("span", [_vm._v(_vm._s(item.meta.title))])
                                : _vm._e(),
                            ]),
                            _c("div", { staticClass: "uni-menu-group" }, [
                              _c("div", { staticClass: "uni-submenu" }, [
                                _c(
                                  "div",
                                  { staticClass: "uni-submenu-list" },
                                  [
                                    _vm._l(item.children, function (child) {
                                      return _c(
                                        "div",
                                        {
                                          key: child.meta.title,
                                          staticClass: "link",
                                          class:
                                            _vm.menuActive == child.meta.title
                                              ? "active"
                                              : "",
                                          on: {
                                            click: function ($event) {
                                              return _vm.jump(child)
                                            },
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(child.meta.title)),
                                          ]),
                                        ]
                                      )
                                    }),
                                    item.children && item.children.length == 0
                                      ? _c("div", [
                                          _c("span", [_vm._v("暂无练习")]),
                                        ])
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]),
                            ]),
                          ],
                          2
                        )
                      : _c(
                          "div",
                          _vm._l(item.children, function (child) {
                            return _c(
                              "el-menu-item",
                              {
                                key: child.meta.title,
                                staticClass: "link",
                                class:
                                  _vm.menuActive == child.meta.title
                                    ? "active"
                                    : "",
                                attrs: { index: child.meta.title },
                                on: {
                                  click: function ($event) {
                                    return _vm.jump(child)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "iconfont",
                                  class: item.meta.icon,
                                }),
                                _c(
                                  "span",
                                  { attrs: { slot: "title" }, slot: "title" },
                                  [_vm._v(_vm._s(child.meta.title))]
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "el-button",
        {
          staticClass: "exit-btn",
          attrs: { type: "primary" },
          on: { click: _vm.exit },
        },
        [
          _c("i", { staticClass: "iconfont icontuichu" }),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isCollapse,
                  expression: "!isCollapse",
                },
              ],
            },
            [_vm._v("退出登录")]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }